<template>
  <div class="adminAddBox">
    <Form ref="addForm" :label-width="120" :model="formCustom" :rules="addRules" inline>
      <Form-item label="用户账号名称：" prop="nikeName">
        <Input v-model="formCustom.nikeName" :maxlength="50" clearable placeholder="请输入"
               style="width: 240px"></Input>
      </Form-item>
      <Form-item label="关联角色：" prop="roleId">
        <Select v-model="formCustom.roleId" :label-in-value='true' clearable filterable style="width: 240px"
                @on-change="changeRole">
          <Option v-for="item in roleList" :value="item.roleId">{{ item.roleName }}</Option>
        </Select>
      </Form-item>
      <br>
      <FormItem label="联系电话：" prop="telephone">
        <Input v-model="formCustom.telephone" :maxlength="11" clearable placeholder="请输入"
               style="width: 240px"></Input>
      </FormItem>
      <FormItem label="账号编码：" prop="adminCode">
        <Input v-model="formCustom.adminCode" clearable placeholder="请输入"
               style="width: 240px"></Input>
      </FormItem>
      <br>
      <FormItem label="登录密码：" prop="password">
        <Input v-model="formCustom.password" :maxlength="50" password placeholder="请输入" style="width: 160px"
               type="password"></Input>
        <Button type="primary" @click="randomPassword">随机密码</Button>
      </FormItem>
      <FormItem label="确认密码：" prop="againPassword">
        <Input v-model="formCustom.againPassword" :maxlength="50" password placeholder="请输入" style="width: 240px"
               type="password"></Input>
      </FormItem>
    </Form>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="addLoading" style="margin-left: 10px" type="primary" @click="handleCommit('addForm')">
        <span v-if="!addLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {adminAdd, roleList} from '@/api/authority'

export default {
  name: 'adminAdd',
  data() {
    return {
      addLoading: false,
      roleList: [], // 关联角色下拉框
      roleId: '', // 下拉框关联角色ID
      formCustom: {
        nikeName: '',
        roleId: '',
        telephone: '',
        adminCode: '',
        password: '',
        againPassword: ''
      },
      addRules: {
        nikeName: [{required: true, message: '用户账号名称不能为空', trigger: 'blur'}],
        adminCode: [{required: true, message: '账号编码不能为空', trigger: 'blur'}],
        roleId: [{required: true, message: '关联角色不能为空', trigger: 'change', type: 'number'}],
        password: [{required: true, message: '登录密码不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let telNum = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,20}$/
              if (telNum.test(value)) {
                callback()
              } else {
                callback(new Error('英文大小写、数字组合，6-20字符'))
              }
            },
            trigger: 'blur'
          }
        ],
        againPassword: [{required: true, message: '确认密码不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.formCustom.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      roleList({
        organizationType: 1
      }).then((res) => {
        this.roleList = res.data.data
      })
    },
    // 获取下拉框关联角色数据
    changeRole(val) {
      if (val !== undefined) {
        this.roleId = val.value
        this.formCustom.roleName = val.label
      }
    },
    // 随机密码
    randomPassword() {
      let random = ''
      let bigLetter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let letter = 'abcdefhijkmnprstwxyz'
      let number = '0123456789'
      let special = '!@#$%&*()'
      random += bigLetter.charAt(Math.floor(Math.random() * bigLetter.length)) // 随机一个大写
      for (let index = 0; index < 5; index++) {
        random += letter.charAt(Math.floor(Math.random() * letter.length))
      }
      random += number.charAt(Math.floor(Math.random() * number.length)) // 随机一个数字
      random += special.charAt(Math.floor(Math.random() * special.length)) // 随机一个数字
      let oldArray = random.split('')
      let randomArray = []
      let num = oldArray.length
      for (let i = 0; i < num; i++) {
        let temp = parseInt(Math.random() * (num - i))
        randomArray.push(oldArray[temp])
        oldArray.splice(temp, 1)
      }
      this.formCustom.password = randomArray.join('')
    },
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/admin',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            nikeName: this.$route.query.nikeName,
            adminCode: this.$route.query.adminCode,
            status: this.$route.query.status
          }
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addLoading = true
          adminAdd(this.roleId, {
            orgId: 1,
            nikeName: this.formCustom.nikeName,
            adminCode: this.formCustom.adminCode,
            telephone: this.formCustom.telephone,
            password: this.formCustom.password
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false
              this.$router.push({name: 'admin'})
            }
          }).catch(() => {
            this.addLoading = false
          })
        }
      })
    }
  }
}
</script>
